<script>
  // Перенос Brand из src_ui/web/src/screens/Auth.tsx — дословно.
  export let kicker = '';
  // латинские надзаголовки набираем пиксельным шрифтом, как на сайте;
  // кириллические остаются на Manrope — в Press Start 2P её нет
  $: lat = /^[\x00-\x7F\s·]+$/.test(String(kicker || ''));
</script>

<div class="brand">
  <div class={'kicker' + (lat ? ' lat' : '')}>{kicker}</div>
  <div class="title">JUST <span class="gold">RP</span></div>
</div>
